import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectToExternalSso } from './users/redirect-to-external-sso.service';
import { OneColumnLayoutComponent } from './layouts/one-column-layout/one-column-layout.component';
import { PageConfig } from 'config/page.config';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { InvalidPermissionsComponent } from './invalid-permissions/invalid-permissions.component';
import { SideNavigationLayoutComponent } from './layouts/side-navigation-layout/side-navigation-layout.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { UsanFormsComponent } from './applications/forms/usan-forms/usan-forms.component';
import { authGuard } from './users/authGuard';
import { FormDetailComponent } from './applications/forms/form-detail/form-detail.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { ApplicantDashboardComponent } from './applicants/applicant-dashboard/applicant-dashboard.component';
import { OrgAdminDashboardComponent } from './admins/orgadmin-dashboard/orgadmin-dashboard.component';
import { AdminDashboardComponent } from './admins/admin-dashboard/admin-dashboard.component';
import { NegotiatorDashboardComponent } from './admins/negotiator-dashboard/negotiator-dashboard.component';
export const routes: Routes = [
  {
    path: PageConfig.paths.landingPage,
    canActivate: [authGuard],
    pathMatch: 'full',
    children: []
  },
  {
    path: PageConfig.paths.usan.root,
    canActivate: [authGuard],
    // data: { authGroup: UserGroup.Admin },
    component: SideNavigationLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        // redirectTo: AppUrl.USAN,
        component: LandingPageComponent
      },
      {
        path: 'forms/:formType',
        pathMatch: 'full',
        component: UsanFormsComponent
      },
      {
        path: 'orgadmin-dashboard',
        pathMatch: 'full',
        component: OrgAdminDashboardComponent
      },
      {
        path: 'application',
        pathMatch: 'full',
        component: FormDetailComponent
      },
      {
        path: 'user-dashboard',
        pathMatch: 'full',
        component: UserDashboardComponent
      },
      {
        path: 'applicant-dashboard',
        pathMatch: 'full',
        component: ApplicantDashboardComponent
      },
      {
        path: 'admin-dashboard',
        pathMatch: 'full',
        component: AdminDashboardComponent
      },
      {
        path: 'negotiator-dashboard',
        pathMatch: 'full',
        component: NegotiatorDashboardComponent
      }
    ]
  },
  {
    path: PageConfig.paths.invalidPermissions,
    pathMatch: 'full',
    component: OneColumnLayoutComponent,
    children: [
      {
        path: '**',
        component: InvalidPermissionsComponent
      }
    ]
  },
  {
    path: PageConfig.paths.login,
    canActivate: [authGuard],
    children : []
  },
  {
    path: PageConfig.paths.callback,
    canActivate: [authGuard],
    children : []
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes, { scrollPositionRestoration: 'top' } // enableTracing only for debugging. Remove this later.
    ),
  ],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule {
}
